import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { LoadingLoginComponent } from '@core/components/login/loading-login/loading-login.component';
import { EntraAuthService } from '@core/services/entra-auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingLoginComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title);
  protected readonly entraAuthService = inject(EntraAuthService);
  readonly msalAuthEnabled = environment.enableMsalAuth;

  ngOnInit(): void {
    this.titleService.setTitle(environment.portalTitle);
    this.addFavicon();

    if (this.msalAuthEnabled) {
      this.entraAuthService.initialize();
    }
  }

  private addFavicon(): void {
    const appIcon = document.createElement('link');
    appIcon.rel = 'icon';
    appIcon.type = 'image/x-icon';
    appIcon.href = `assets/${environment.favicon}`;
    document.head.appendChild(appIcon);
  }
}
